import React, { Component } from 'react';
import _ from 'lodash'
import { setState } from './lib/state'
import { updatePath, logPath } from './lib/path'
import getInitialState from './initial-state'
import t from './translate/t'

import Home from './Home.jsx'
import Quiz from './Quiz.jsx'

class App extends Component {
  componentDidMount() {
    this.fetchData()

    window.onpopstate = this.onBackButtonEvent.bind(this)
    logPath()
  }

  fetchData() {
    const url = process.env.NODE_ENV === 'development' ? "http://localhost:3001/data/" : "/data"
    fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "GET",
    })
      .then(result => result.json())
      .then(data => {
        const { candidates } = data
        const allCandidates = {}
        for (const district in candidates) {
          allCandidates[district] = _.shuffle(candidates[district])
          setState({ allCandidates })
        }
      })
      .catch(error => {
        console.error(error)
        setTimeout(this.fetchData, 5000)
      })
  }

  onBackButtonEvent(event) {
    if (event.state) {
      setState(event.state)
    } else {
      setState(getInitialState())
    }
  }

  setLanguage(event, language) {
    if (event.metaKey) {
      return
    }
    event.preventDefault()

    setState({ language })
    updatePath(true)
  }

  reset() {
    setState(getInitialState(true))
    updatePath(true)
  }

  render() {
    const { language, district, SSR } = this.props
    const activeFi = language === 'fi' ? 'active' : ''
    const activeEn = language === 'en' ? 'active' : ''

    return <div id="app" className="bg-white flex flex-col">
      <div className="header flex flex-row px-2">
        <div className="flex-1 mb-0"><h1 className="inline">pikavaalikone</h1></div>
        <div className="text-right -mx-2 select-none">
          <a href="/" className={"link mx-2 " + activeFi} onClick={event => this.setLanguage(event, 'fi')}>Fi</a>
          <a href="/en/" className={"link " + activeEn} onClick={event => this.setLanguage(event, 'en')}>En</a>
          <span className="button mx-2" onClick={() => this.reset()}>{t('reset')}</span>
        </div>
      </div>

      {SSR ? null : !district
        ? <Home {...this.props} />
        : <Quiz {...this.props} />
      }

      {SSR ? null : <div className="px-2 text-center py-8">
        <p className="mb-8">{t('footerInfo')}</p>

        <h3>{t('contact')}:</h3>
        <p className="mb-8 text-lg"><a href="mailto:hannu@fell.fi">hannu@fell.fi</a></p>
        <p className="mb-8 text-lg"><a href="https://fell.fi">Fell Software oy</a></p>
        <p>{t('privacy')} <span className="link" onClick={() => setState({ noLogging: true })}>{t('clickhere')}</span>.</p>
      </div>}
    </div>
  }
}

export default App
